export const PLAN_AMOUNTS = {
  year: 7000,
  month: 700,
}

export const TERMS = {
  year: 'yearly',
  month: 'monthly',
}
